// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"72fe0985","85":"94f47d22","198":"18543f77","378":"a854f8ab","453":"8287ce99","532":"4e5fe5f4","591":"644970db","625":"706e49c9","722":"8e26c3b6","732":"468627b0","736":"8105bd5c","895":"6dfb7b1f","972":"e04b1dc2"}[chunkId] + ".chunk.js";
};